export type ArchiveVisibility = 'include' | 'only';

/** Keep old Archived-tab links working while archive visibility moves into filters. */
export function archiveVisibility(value?: string, tab?: string): 'hide' | ArchiveVisibility {
  if (tab === 'excluded' || value === 'only') return 'only';
  return value === 'include' ? 'include' : 'hide';
}

export function matchesArchive(isArchived: boolean, value?: string, tab?: string): boolean {
  const visibility = archiveVisibility(value, tab);
  return visibility === 'include' || (visibility === 'only' ? isArchived : !isArchived);
}

export function archiveQueryGroup(column: string, value?: string, tab?: string): string | null {
  const visibility = archiveVisibility(value, tab);
  if (visibility === 'include') return null;
  if (visibility === 'only') return `${column}.eq.true`;
  return `or(${column}.is.null,${column}.eq.false)`;
}
